import emptyConfig from "./empty";
import STO from "./companies/STO";
import delivery from "./companies/delivery";
import hotel from "./companies/hotel";
import { Config } from "./companies/config";

const config: Record<string, Config> = {
  STO: STO,
  delivery: delivery,
  hotel: hotel,
};

export const getConfig = (key: string = ""): Config => {
  if (config[key]) {
    return config[key];
  } else {
    return emptyConfig;
  }
};
